import Cookies from 'universal-cookie';
import { round } from './round';
const cookies = new Cookies();
export const numberToString = (
  number = 0,
  decimalPlaces = 2,

  thousandSeparator = '.',
  separator = cookies.get('decimalSeparator')
) => {
  if (number === null) return '';
  if (!separator) separator = ',';
  if (
    number === '' ||
    Number.isNaN(parseFloat(number)) ||
    number == null ||
    number == undefined
  )
    return `0${separator}`;
  var roundedNumber = parseFloat(
    round(parseFloat(number), decimalPlaces)
  ).toFixed(decimalPlaces);

  let parts = roundedNumber.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

  return decimalPlaces ? parts.join(separator) : parts[0];
};

export const stringToNumber = (
  string = '0',
  decimalPlaces = 2,
  thousandSeparator = '.',
  separator = cookies.get('decimalSeparator')
) => {
  if (!string) return 0;
  if (!separator) separator = ',';
  const normalizedString = string
    .split(thousandSeparator)
    .join('') // removes all thousand separators
    .replace(separator, '.');

  const number = decimalPlaces
    ? normalizedString
    : round(parseFloat(normalizedString), decimalPlaces);
  return isNaN(number) ? 0 : number;
};
